import { render } from "./button.vue?vue&type=template&id=7c702938"
const script = {}

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__